import React, { useState } from "react";
import {
  FiClock,
  FiHeadphones,
  FiMail,
  FiMapPin,
  FiPhone,
  FiPrinter,
  FiSend,
  FiShield,
  FiStar,
  FiUser,
  FiUsers,
} from "react-icons/fi";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { HiOutlineOfficeBuilding, HiOutlineGlobeAlt } from "react-icons/hi";
import Navbar from "../components/navbar";
import BrochureForm from "../components/EnquiryForm";
import CTAButtons from "../components/sticky-button";
import Footer from "../components/Footer";
import PageHeader from "../about/PageHeader";
import ReachOutForm from "./ContactUs";
import "./ContactPage1.css";

const quickContacts = [
  {
    icon: FiPhone,
    label: "Call Us",
    content: <><a href="tel:02228840484">022 - 2884 0484</a><a href="tel:+912267308301">91 - 022 - 67308301/02</a></>,
  },
  {
    icon: FiMail,
    label: "Email Us",
    content: <a href="mailto:timscdr@thakureducation.org">timscdr@thakureducation.org</a>,
  },
  {
    icon: FiPrinter,
    label: "Office Fax",
    content: <span>022 - 28852527</span>,
  },
  {
    icon: HiOutlineGlobeAlt,
    label: "Website",
    content: <a href="https://www.timscdrmumbai.in" target="_blank" rel="noreferrer">www.timscdrmumbai.in</a>,
  },
];

const trustItems = [
  { icon: FiClock, title: "Quick Response", text: "We aim to respond to all inquiries within 24 hours." },
  { icon: FiUsers, title: "Expert Support", text: "Our dedicated team is here to assist you." },
  { icon: FiShield, title: "Trusted Institution", text: "Over two decades of excellence in education." },
  { icon: FiStar, title: "Student First", text: "Your success and growth are our priority." },
];

const ContactPage = () => {
  const [showForm, setShowForm] = useState(false);
  return (
    <div className="contact-page">
      <Navbar setShowForm={setShowForm} />
      <PageHeader
        title="Contact Us"
       
        crumbs={[{ label: "Home", href: "/" }, { label: "Contact Us" }]}
      />

      {showForm && <BrochureForm setShowForm={setShowForm} />}
      <CTAButtons />

      <main className="contact-content">
        <section className="contact-top-grid" aria-label="Contact form and quick contact information">
          <ReachOutForm />

          <aside className="contact-card quick-contact-card">
            <h2><FiHeadphones /> Quick Contact</h2>
            <div className="quick-contact-list">
              {quickContacts.map(({ icon: Icon, label, content }) => (
                <div className="quick-contact-item" key={label}>
                  <span className="quick-contact-icon"><Icon /></span>
                  <div><strong>{label}</strong>{content}</div>
                </div>
              ))}
            </div>
          </aside>
        </section>

        <section className="contact-info-grid" aria-label="Location, address, and social media">
          <article className="contact-card location-card">
            <h2 className="contact-card-title"><span className="contact-heading-icon"><FiMapPin /></span> Our Location</h2>
            <div className="contact-map">
              <iframe
                title="TIMSCDR location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3768.2117562094243!2d72.87190007520792!3d19.207802848512217!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b73815024765%3A0xc3cd835a6875d9e!2sThakur%20Institute%20of%20Management%20Studies%2C%20Career%20Development%20and%20Research%20(TIMSCDR)!5e0!3m2!1sen!2sin!4v1714000000000!5m2!1sen!2sin"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <a className="directions-link" href="https://maps.app.goo.gl/1R6FwbUpLXa4bCbd6" target="_blank" rel="noreferrer"><FiSend /> Get Directions</a>
          </article>

          <article className="contact-card address-card">
            <h2 className="contact-card-title"><span className="contact-heading-icon"><HiOutlineOfficeBuilding /></span> Address</h2>
            <strong>Thakur Institute of Management Studies,<br />Career Development and Research</strong>
            <div className="address-divider" />
            <p>Thakur Educational Campus,<br />Shyamnarayan Thakur Marg,<br />Thakur Village, Kandivali (East),<br />Mumbai, Maharashtra 400101</p>
          </article>

          <article className="contact-card follow-card">
            <h2 className="contact-card-title"><span className="contact-heading-icon"><FiUsers /></span> Follow Us</h2>
            <p>Stay connected with us on social media<br />for the latest updates.</p>
            <div className="contact-socials">
              <a className="facebook" href="https://www.facebook.com/timscdrmumbai.in" aria-label="Facebook"><FaFacebookF /></a>
              <a className="instagram" href="https://www.instagram.com/timscdr.official" aria-label="Instagram"><FaInstagram /></a>
              <a className="linkedin" href="https://www.linkedin.com/school/thakurinstituteofmanagementstudiescareerdevelopmentandresearch/posts/?feedView=all" aria-label="LinkedIn"><FaLinkedinIn /></a>
              <a className="youtube" href="https://www.youtube.com/@TIMSCDR.mumbai" aria-label="YouTube"><FaYoutube /></a>
            </div>
          </article>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ContactPage;
